import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { RealityCheckData } from "@obg/ngx.core";
import { CurrencyService } from "@obg/ngx.global";

@Component({
	selector: "obg-sga-reality-check",
	templateUrl: "./sga-reality-check-info.component.html",
	styleUrls: ["./sga-reality-check-info.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SgaRealityCheckComponent {
	@HostBinding("class.obg-sga-reality-check") hostCssClass = true;

	@Input() set data(value: RealityCheckData | undefined) {
		if (!value) {
			return;
		}

		const totalWins = value.totalWins || 0;
		const totalBets = value.totalBets || 0;
		this.totalLosses = this.currency.format(totalBets - totalWins);
		this.totalWins = this.currency.format(totalWins);
		this._data = value;
	}

	get data() {
		return this._data;
	}

	totalLosses: string | null | undefined;
	totalWins: string | null | undefined;

	private _data: RealityCheckData | undefined;
	constructor(private currency: CurrencyService) {}
}
